import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { useSelector } from 'react-redux';
import { SolarSystemLoading } from 'react-loadingg';
import { sendReportToClass } from '../../../utils/API';
import { success } from '../../../utils/Toast';
import { HomePage } from '../../../translations/trans';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const SendReportToClass = ({ classId, name }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(null);
    const [formTo, setToDate] = useState(null);
    const [message, setMessage] = useState(null);
    const [type, setType] = useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const loggedUser = useSelector((state) => state.loggedUser);

    const handleSendReportToAllClass = async () => {
        setLoading(true);
        try {
            const res = await sendReportToClass({
                classId,
                from: date,
                to: formTo,
                about: type
            }, loggedUser?.user?._id);
            
            if (res?.data?.case) {
                success(res?.data?.message);
                handleClose();
            }
        } catch (e) {
            if (e.response) {
                setMessage(e.response.data.message);
            }
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return date ? date.toISOString().split('.')[0] + '+03:00' : null;
    };

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => setMessage(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const { lang, dir } = useSelector(({ language }) => ({
        lang: language.lang,
        dir: language.dir
    }));

    return (
        <div className="text-center">
            {/* Styled button to open modal */}
            <button
                className="btn btn-primary px-4 py-2"
                onClick={handleShow}
            >
                {name || HomePage.sendReports[lang]}
            </button>

            {/* Modal Report */}
            <Modal show={show} onHide={handleClose} centered dir={dir}>
                <Modal.Body>
                    {message && <Alert variant="danger">{message}</Alert>}

                    <div>
                        <div>
                            <label>{HomePage.from[lang]}:</label>
                            <DatePicker
                                selected={date ? new Date(date) : null}
                                onChange={(date) => setDate(formatDate(date))}
                                dateFormat="yyyy-MM-dd"
                                className="form-control w-100"
                                placeholderText="Select Date"
                            />
                        </div>

                        <div className="mt-4">
                            <label>{HomePage.to[lang]}:</label>
                            <DatePicker
                                selected={formTo ? new Date(formTo) : null}
                                onChange={(date) => setToDate(formatDate(date))}
                                dateFormat="yyyy-MM-dd"
                                className="form-control w-100"
                                placeholderText="Select Date"
                            />
                        </div>

                        <div className="mt-3">
                            <select
                                className="form-control"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                            >
                                <option hidden>Choose Report Type</option>
                                <option value="test">Test</option>
                                <option value="homework">H.W</option>
                                <option value="attendance">Attendance</option>
                                <option value="activity">Activity (homework & attendance)</option>
                                <option value="mock">Mock</option>
                                <option value="mock-activity" >Mock & Activity</option>
                            </select>
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <button
                            onClick={handleSendReportToAllClass}
                            className="btn btn-success px-4 py-2"
                        >
                            {HomePage.sendMsg[lang]}
                        </button>
                    </div>

                    {loading && (
                        <div className="shadow text-center p-3" style={{ backgroundColor: "white" }}>
                            <SolarSystemLoading />
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SendReportToClass;
